import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-tencent-color-large.tsx
/**
* icon.24.logo.tencent.color.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iIzAwNTJkOSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAuMDI1IDMuMzkgMjEgMTAuMjc5bC04LjI4NS4wMTEtMi4xMDYgMTAuMzE5SDYuNTEzbDIuMTA2LTEwLjMzSDQuNzU2TDMgNi44MzRoNi4zMjF6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26873-63646
*/
const Icon24LogoTencentColorLarge = memo(function Icon24LogoTencentColorLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "#0052d9",
			fillRule: "evenodd",
			d: "M10.025 3.39 21 10.279l-8.285.011-2.106 10.319H6.513l2.106-10.33H4.756L3 6.834h6.321z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24LogoTencentColorLarge };

//# sourceMappingURL=icon-24-logo-tencent-color-large.js.map